import { GuestSegmentTypes } from '../guestSegment/guestSegment.types';
import { EmailContent } from '../campaign/content.types';

export enum JourneyResultTypes {
  MANUAL = 'Manual',
  AUTO = 'Auto',
}

export enum JourneyTypes {
  SEGMENTS = 'Segments',
  OTHERS = 'Others',
}

export enum JourneyOtherEnum {
  BIRTHDAY = 'Birthday',
  ANNIVERSARY = 'Anniversary',
  LOYALTY = 'Loyalty',
}

export enum JourneyChannelEnum {
  EMAIL = 'Email',
  TEXT = 'Text',
}

export enum JourneyPositionEnum {
  LOGO = 'logo',
  MAIN = 'main',
  ITEM = 'item',
  DEAL = 'deal',
  SPOTLIGHT = 'spotlight',
}

// Segment Joruney Descriptions
export enum JourneySegmentNames {
  FIRST_VISIT = 'First Visit',
  SECOND_VISIT = 'Second Visit',
}
export enum JourneySegmentDescription {
  FIRST_VISIT = 'Start by welcoming new guests right after their first order',
  SECOND_VISIT = 'Start by introducing your loyalty program to those guests that are back after their first visit',
  LAST = 'Follow-up with your guests and Spotlight something that you offer',
}

// Other Joruney Descriptions
export enum JourneyOtherNames {
  ONE_MONTH_PRIOR = 'One Month Prior',
  ONE_WEEK_PRIOR = 'One Week Prior',
  ON_THE_DAY = 'On The Day',
  ONE_DAY_AFTER_SIGNUP = 'One Day After Sign-Up',
  TIER_UPGRADE = 'Tier Eligibility/Upgrade',
  REDEEM_REMINDER = 'Reminder to Redeem',
}

export enum JourneyBirthdayDescription {
  ONE_MONTH_PRIOR = 'Welcome guests warmly within a month of their birthday',
  ONE_WEEK_PRIOR = 'Remind guests to celebrate with you a week before their birthday',
  ON_THE_DAY = 'Spotlight something special to celebrate your guest’s birthday',
}

export enum JourneyAnniversaryDescription {
  ONE_WEEK_PRIOR = 'Welcome guests warmly a week before their anniversary',
  ON_THE_DAY = 'Spotlight something special to celebrate your guest’s anniversary',
}

export enum JourneyLoyaltyDescription {
  ONE_DAY_AFTER_SIGNUP = 'Start by informing customers about the loyalty program 1 day after they sign up for an account',
  TIER_UPGRADE = 'Inform customers when they accumulate enough points to access a new tier of rewards',
  REDEEM_REMINDER = 'Remind customers about the points they have saved up and what they can use them for',
}

export interface IJourneyEmailBody extends Partial<EmailContent> {
  main?: string;
  subject?: string;
  deal?: {
    header: string;
    subtitle?: string;
  };
  spotlight?: string;
  item?: string;
  end?: string;
  templateUrl?: string;
  extraCtas?: EmailContent['cta'][];
  contentOrder?: string[];
  globalSettings?: EmailContent['globalSettings'] & {
    headingFontFamily?: string;
    subheadingFontFamily?: string;
    bodyFontFamily?: string;
    buttonFontFamily?: string;
  };
}

export interface IJourneyEmailTemplate {
  main: string;
  deal?: number;
  deal_header?: string;
  deal_subtitle?: string;
  spotlight?: string;
  spotlight_link?: string;
  spotlight_image?: string;
  item?: string;
  item_image?: string;
  end: string;
}

export interface IJourneyDataResponse {
  id: number;
  name: string;
  description: string;
  other?: JourneyOtherEnum;
  guestSegment?: GuestSegmentTypes;
  type: JourneyTypes;
  channel: JourneyChannelEnum;
  isEnabled: boolean;
  stage: number;
  body?: string;
  email: IJourneyEmailBody;
  templateURL?: string | null;
  results?: IJourneyResults[];
  positions: JourneyPositionEnum[];
}

export interface IJourneyStatResponse {
  customers?: number;
  sent?: number;
  delieverd?: number;
  rate?: number;
}

export interface IUpdateJourneyRequest {
  id: number;
  body: string;
  email: IJourneyEmailBody;
  channel: JourneyChannelEnum;
  itemId?: number;
  dealId?: number;
  spotlightId?: number;
  templateURL?: string | null;
}

export interface IUpdateJourneyStatus {
  name: string;
  type: JourneyTypes;
  guestSegment?: GuestSegmentTypes;
  other?: JourneyOtherEnum;
  isEnabled: boolean;
  stage: number;
  isSend?: boolean;
}

export interface IJourneySmsDto {
  mobileNumber: string;
  messageBody: string;
  senderID?: string;
}
export interface IJourneyEmailDto {
  subject: string;
  TemplateName: string;
  sourceEmail: string;
  receipientEmail: { email: string; variables: any }[];
  variables: any;
  region: string;
  sourceName: string;
  replyEmail?: string;
  templateURL?: string | null;
}

export interface IJourneyEventBridge {
  name?: string;
  journeyId: number;
  customerId: string;
  phoneNumber?: string;
  emailAddress?: string;
  channel: JourneyChannelEnum;
  businessId: number;
}

export interface IJourneySmsEventBridge extends IJourneyEventBridge, IJourneySmsDto {}
export interface IJourneyEmailEventBridge extends IJourneyEventBridge, IJourneyEmailDto {}

export interface IJourneySqs {
  name?: string;
  type: JourneyResultTypes;
  journeyId: number;
  businessId: number;
  channel: JourneyChannelEnum;
  customers: {
    id: string;
    emailAddress?: string;
    phoneNumber?: string;
    businessId: number;
  }[];
  data: Omit<IJourneyEmailDto, 'receipientEmail'> | Omit<IJourneySmsDto, 'mobileNumber'>;
}

export interface IJourneyResultCustomers {
  id: string;
  phoneNumber: string;
  emailAddress: string;
  fullName: string;
}

export interface IJourneyResults {
  id?: number;
  journeyId: number;
  total: number;
  sent: number;
  failed: number;
  date: Date;
  type?: JourneyResultTypes;
  channel: JourneyChannelEnum;
  data: Omit<IJourneyEmailDto, 'recieptEmail'> | Omit<IJourneySmsDto, 'mobileNumber'>;
  customers?: IJourneyResultCustomers[];
  invalidEmailCount?: number;
}

export interface CustomerWithJourney {
  customerId: string;
  businessId: number;
  phoneNumber: string;
  emailAddress: string;
  fullName: string;
  segmentUpdatedAt?: string;
  channel: JourneyChannelEnum;
  name: string;
  content: string | IJourneyEmailTemplate;
  sourceName: string;
  journeyId: number;
  templateURL?: string;
}
